import {Box, Heading} from '@salesforce/retail-react-app/app/components/shared/ui';

export function BuildAndCustomize() {
  return (
    <Box borderColor="gray.200" borderRadius="md" borderWidth={1} padding={4}>
      <Heading as="h4">Build and Customize</Heading>
    </Box>
  );
}
